// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields} = state;

	/**
	 * If fund is checked we need to see that the amounts meet our minimum limits
	 */
	if (fields.radio_fund_spets.options[1].checked) {
		if (fields.monthly_save === '' && fields.onetime_save === '') {
			return false;
		}

		if (fields.onetime_save !== '' && fields.onetime_save < 1000) {
			return false;
		}

		if (fields.monthly_save !== '' && fields.monthly_save < 500) {
			return false;
		}
	}
	else if (!fields.radio_fund_spets.options[0].checked) {
		return false;
	}

	/**
	 * If autogiro is checked we also need to enter a bank account and bank name
	 */
	if (fields.radio_customer_autopay.options[1].checked) {
		if (fields.account_number.length === 0 || fields.claering_nr.length !== 4 || fields.bank_name.length === 0) {
			return false;
		}
	}
	else if (!fields.radio_customer_autopay.options[0].checked) {
		return false;
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Placering.fulfillment.js